<script>
export default {
    name: "SupplierPaymentDetailsPrint",

    data() {

        return {
            paymentDetails: {},
                 voucherItems: {
                voucherDetails: [],
                dedcutions: [],
            },
            supplier: {},
        };
    },

    computed: {

        total() {
            if(!this.voucherItems.voucherDetails.length) return 0;

            return this.voucherItems.voucherDetails
                .map(voucherItem => parseFloat(voucherItem.voucherAmount))
                .reduce((sum,amt) => sum+amt);
        },

        customDeductions() {
            if(!this.voucherItems.dedcutions.length) return 0;

            const customDeductions = this.voucherItems.dedcutions.filter(ded => !ded.isKra);

            return customDeductions.length ? customDeductions
                .map(deduction => parseFloat(deduction.deductionAmount))
                .reduce((sum,amt) => sum+amt) : 0;
        },

        kraDeductions() {
            if(!this.voucherItems.dedcutions.length) return 0;

            const deductions = this.voucherItems.dedcutions.filter(ded => ded.isKra);

            return deductions.length ? deductions
                .map(deduction => parseFloat(deduction.deductionAmount))
                .reduce((sum,amt) => sum+amt) : 0;
        },
    },

    mounted() {

        this.$root.loading=true;
        Promise.all([this.fetchSpecificSupplierPayment(), this.fetchSupplier(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => {this.$root.loading=false;});
    },

    methods: {

        fetchVoucherDetails() {

            return this.$http.get(`Finance/GetPaymentVoucherDetails?VoucherNo=${this.$route.params.remittanceNo}&VoucherType=1`).then(response => {
                this.voucherItems=response.data;
            }).catch(() => {});
        },

        fetchSupplier() {
            let url = `SupplierSetup/GetSpecificSupplier`;
                url += `?SupplierID=${this.$route.query.supplierId}`;
    
            return this.$http.get(url).then(response => {
                    this.supplier=response.data.length ? response.data[0] : {};
                }).catch(() => {});
        },fetchSpecificSupplierPayment() {
            let url = `SupplierPayments/GetSpecificSupplierPayment`;
                url += `?RemittanceNo=${this.$route.params.remittanceNo}`;
    
            return this.$http.get(url).then(response => {
                    this.paymentDetails=response.data.length ? response.data[0] : {};
                }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex justify-center my-3">
            <tail-address-header></tail-address-header>
        </div>
        <div class="w-full text-center">
            <h5 class="text-lg uppercase font-bold ">SUPPLIER PAYMENT SLIP 
               </h5>
        </div> <div class="w-full p-3 text-center my-3">
            <h5 class="text-lg uppercase">Remittance NO: 
                {{$route.params.remittanceNo}}</h5>
        </div>
        <div class="w-full flex flex-wrap p-3">
            <div class="flex-1">
                <h5 class="text-base font-medium">Supplier: {{supplier.names}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Contact: {{supplier.phoneno || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Pin No: {{supplier.piN_No || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="text-base font-medium">Website: {{supplier.website || `-`}}</h5>
            </div>
          
        </div>
        
        <div class="my-2 p-2 bg-gray-300 w-full flex flex-wrap">
           <div class="flex-1">
                <h5 class="font-medium text-base">Date: 
                    {{ paymentDetails.datePosted | dateFormat}}  </h5>
            </div> <div class="flex-1">
                <h5 class="font-medium text-base">Mode: 
                    {{ paymentDetails.mode}}  </h5>
            </div><div class="flex-1">
                <h5 class="font-medium text-base">Amount: 
                    {{ paymentDetails.paidAmount| numberFormat}}  </h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium text-base">Ref: 
                    {{ paymentDetails.paymentRef }}
                </h5>
            </div>
            
           
        </div>
         <div class="md:w-1/2 w-full p-tiny">
             
                <h5 class="font-medium text-base">Desription: 
                {{ paymentDetails.description }}</h5>
        </div> <div class="md:w-1/2 w-full p-tiny">
             
                <h5 class="font-medium text-base">Approval Memo: 
                {{ paymentDetails.postMemo }}</h5>
        </div>
    </div>
</template>
<style scoped>
@media print {
    tr { page-break-inside:avoid; page-break-after:auto; overflow: visible; }
    td {page-break-inside:avoid; page-break-after:auto; overflow: visible; }
    thead { display: table-row-group; }
}
</style>